import * as z from 'zod';
export const StoredStateSchema = z.object({
    openedAt: z.int().nonnegative(),
    favoritesCountedFrom: z.int().nonnegative(),
    lockedAt: z.int().nonnegative().optional(),
});
export const StoredGameInfoSchema = z.object({
    id: z.uuidv7(),
    state: StoredStateSchema,
    createdAt: z.int().nonnegative(),
});
export const GRACE_PERIOD_MS = 30_000;
//# sourceMappingURL=gameInfo.js.map